import { render, staticRenderFns } from "./UploaderItems.vue?vue&type=template&id=091f8ca4&scoped=true"
import script from "./UploaderItems.vue?vue&type=script&lang=js"
export * from "./UploaderItems.vue?vue&type=script&lang=js"
import style0 from "./UploaderItems.vue?vue&type=style&index=0&id=091f8ca4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091f8ca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('091f8ca4')) {
      api.createRecord('091f8ca4', component.options)
    } else {
      api.reload('091f8ca4', component.options)
    }
    module.hot.accept("./UploaderItems.vue?vue&type=template&id=091f8ca4&scoped=true", function () {
      api.rerender('091f8ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/default/UploaderItems.vue"
export default component.exports